// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__tVWja","topBottomGutter":"Layout_topBottomGutter__2crPC"};